
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Bei Ländern dieser Gruppe ist die Situation ungewiss: Sie haben eine
`}<strong parentName="p">{`Verdopplungszeit der bestätigten Fallzahlen von zwischen 30 und 200 Tagen`}</strong>{` –
in der Grafik sind die Länder mit `}<strong parentName="p">{`mehr als 50’000 Fällen`}</strong>{` hervorgehoben.
Während sich bei einigen Mitgliedern dieser Gruppe ein langsamer, aber deutlich
erkennbarer Abwärtstrend abzeichnet (`}<strong parentName="p">{`Kanada`}</strong>{`, `}<strong parentName="p">{`USA`}</strong>{` und
`}<strong parentName="p">{`Grossbritannien`}</strong>{`), verläuft die Kurve anderer Länder noch unregelmässig und
ohne erkennbare Richtung (`}<strong parentName="p">{`Schweden`}</strong>{` und `}<strong parentName="p">{`Russland`}</strong>{`).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;